import type { FaireProductEntity } from "../../entity_types/product";

export const p_x4rdsgp7bm: FaireProductEntity = {
  token: "p_x4rdsgp7bm",
  type: "product",
  name: "E. Frannie Pack (Navy)",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl: "https://cdn.faire.com/fastly/357666bd62584d69dcf3cfe1b068439b7859014a483be12421763bd662393c19.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/43ba9d8bb6d520380ca897626304d570dfb1ca95cc5294054701441389ee8572.png",
    "https://cdn.faire.com/fastly/bfaa2b424a2b5ee6cd63665a69842b19de191a4e9af03d729beeee9373311acd.png",
    "https://cdn.faire.com/fastly/90619d575d1f1a13a19d1cb3c2da25593612f8d7b3446fad4067f773cc668f60.png"
  ],
  priceDollars: 9,
  description: "Meet your Little Notes® sidekick! The E. Frannie Pack is ready for bags, cars, coat pockets...leave a note under someone's windshield. Under someone's doormat. A smile for the bank teller at the other end of that frightening, traveling tube. Anywhere joy might be needed. It snuggly fits about 25 Little Notes®. The E.Frannie Pack is cute, practical, and the perfect gift for anyone who loves sprinkling more joy into the world.",
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:37:19.802Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
